export var ADD_MAIN_CONTROLS_NAMESPACE = 'addMainControls';
export var ADD_FOCUS_DRAWER_CONTROLS_NAMESPACE = 'addFocusDrawerControls';
export var ADD_OVERLAY_CONTROLS_NAMESPACE = 'addOverlayControls';
export var MILLISECONDS_TO_DELAY_NOTIFICATION_CLOSING_ANIMATION = 7000;
export var MILLISECONDS_TO_DELAY_NOTIFICATION_CLOSE = 1000;